import React from 'react';

import WidgetInput from './WidgetInput';
import PropsVoucherDiscountCode from './interfaces/PropsVoucherDiscountCodeInterface';

export default class WidgetVoucherDiscountCode extends WidgetInput<PropsVoucherDiscountCode> {
    private unappliedValue: string = '';

    constructor(props: PropsVoucherDiscountCode) {
        super(props);
        this.deleteVoucherDiscount = this.deleteVoucherDiscount.bind(this);
    }

    deleteVoucherDiscount(event: React.MouseEvent<HTMLInputElement>) {
        this.props.handleChange(this.props.name, '');
        event.preventDefault();
    }

    onChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.unappliedValue = event.target.value.trim();
        this.props.handleChange(this.props.name, event.target.value, false);
    }
    onApply(event: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(this.props.name, this.unappliedValue, true);
    }

    render(): React.DetailedReactHTMLElement<React.HTMLAttributes<HTMLElement>, HTMLElement> {
        let classes = [this.props.recrastype + 'Input'];

        if (this.props.valid) {
            classes.push('valid');
        } else if (this.getRenderValue()) {
            classes.push('invalid');
        } else {
            classes.push('empty');
        }

        let input = React.createElement('input', {
            autoCapitalize: 'none',
            autoCorrect: 'off',
            id: this.props.id,
            name: this.props.name,
            key: this.props.id,
            type: this.props.type,
            required: this.props.required,
            value: this.unappliedValue || this.getRenderValue(),
            disabled: this.props.disabled || this.props.valid === true,
            onChange: this.onChange.bind(this),
            className: classes.join(' '),
        });

        let extraBtn = null;

        if (this.props.valid) {
            extraBtn = React.createElement(
                'button',
                {
                    onClick: this.deleteVoucherDiscount,
                    type: 'button',
                    className: 'btnDelete',
                },
                '✕'
            );
        } else {
            extraBtn = React.createElement(
                'button',
                {
                    onClick: this.onApply.bind(this),
                    type: 'button',
                    className: 'btnApply',
                },
                this.props.settings.applyText
            );
        }
        return React.createElement(
            'div',
            {
                className: 'discountWrapper',
            },
            input,
            extraBtn
        );
    }
}
